export default { shopId: '', token: '', shopifyToken: '' };
